module.exports = __webpack_public_path__ + "static/media/hippo.33d6fcc6.svg";